import { withMutation, Mutations } from 'gql';

const withUpdateCustomLabelOffset = withMutation({
  name: 'UPDATE_CUSTOM_LABEL',
  mutation: Mutations.UPDATE_CUSTOM_LABEL,
  mutateProp: 'updateCustomLabelOffset',
  getMutationArgs(x, y) {
    const { phaseId, label } = this.props;
    return {
      variables: {
        customLabelUpdateInput: {
          phaseId,
          customLabelId: label.id,
          value: label.value,
          color: label.color,
          labelOffset: { x, y },
          visible: label.visible,
        },
      },
    };
  },
});

export default withUpdateCustomLabelOffset;
